'use client';

import { useTranslations } from 'next-intl';
import { HeaderNotification } from 'components/pcc-components';
import { useNotificationsDrawer } from 'components/notifications/notifications-drawer-context';
import { Notification } from 'services/notifications/types';

const NotificationClient = ({
  isMobile,
  notifications = []
}: {
  isMobile?: boolean;
  notifications?: Notification[];
}) => {
  const t = useTranslations();
  const notificationsDrawer = useNotificationsDrawer();
  const title = t('NOTIFICATIONS');
  const ariaLabelTitle = `${t('VIEW_ALL')} ${title}`;
  const notificationID = `headerNotification${isMobile ? 'Mobile' : ''}`;

  const hasNewNotifications = notifications?.filter(
    (data) => data.isRead === false && data.isDismissed === false
  );

  return (
    <HeaderNotification
      action={notificationsDrawer?.openDrawer}
      id={notificationID}
      isCurrent={false}
      title={title}
      ariaLabel={ariaLabelTitle}
      hasNotifications={hasNewNotifications?.length > 0}
    />
  );
};

export default NotificationClient;
